// libs
import { useContext, useEffect, useState } from "react";
import { useMountedRef, captureError } from "@swiggy-private/core-ui";
import { isPhonepeSdkAvailable } from "@payment-client/helpers/PaymentHelper";
import { useSessionStorage } from "@swiggy-private/checkout-core";
import { ShowPaymentContext } from "@payment-client/contexts/ShowPaymentContext";

const UsePhonepeSdkAvailable = (): boolean => {
    const isMountedRef = useMountedRef();
    const { paymentResponse } = useContext(ShowPaymentContext);
    const [state, setState] = useSessionStorage<{ available: boolean } | null>("phonepe_sdk_available", null);
    const [availableCallInProgress, setAvailableCallInProgress] = useState(false);
    const tenant = paymentResponse ? paymentResponse.tenant : undefined;

    useEffect(() => {
        if (state != null || availableCallInProgress) {
            return;
        }
        setAvailableCallInProgress(true);
        isPhonepeSdkAvailable(tenant)
            .catch((err) => {
                captureError(err);
                return false;
            })
            .then((available) => {
                if (isMountedRef.current) {
                    setState({ available });
                    setAvailableCallInProgress(false);
                }
            });
    }, [isMountedRef, state, setState, availableCallInProgress, tenant]);

    return state?.available ?? false;
};

export default UsePhonepeSdkAvailable;
